<h6 [ngClass]="[fontWeight, fontColor, cursorType, textDecoration, textLine]">
  <ng-content></ng-content>
</h6>
